








































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { SitePerm, siteAdminPermApis, PermMembers, roleType } from '../../api';

@Component({ components: {} })
export default class PermMembersDialog extends Vue {
  @Prop() siteId!: number;
  dialogVisible = false;
  perm: SitePerm | null = null;
  members: PermMembers | null = null;
  roleType = roleType;
  loading = true;

  show(perm: SitePerm) {
    this.perm = perm;
    siteAdminPermApis.getPermMembers(this.siteId, perm.name).then(members => {
      this.members = members;
      this.loading = false;
    });
    this.dialogVisible = true;
  }

  onClosed() {
    this.perm = null;
    this.members = null;
    this.loading = true;
  }
}
